import React from 'react'
import ReportsPanel from '../components/ReportsPanel'

const ReportsPage = () => {
  return (
    <div className="space-y-6">
      {/* Header da Página */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
              📊 Relatórios e Analytics
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Central de relatórios gerenciais com dados reais do sistema VIPLOC
            </p>
          </div>
          <div className="flex items-center space-x-3">
            <div className="bg-green-100 dark:bg-green-900/20 text-green-800 dark:text-green-300 px-3 py-1 rounded-full text-sm font-medium">
              ✅ Sistema Operacional
            </div>
            <div className="bg-blue-100 dark:bg-blue-900/20 text-blue-800 dark:text-blue-300 px-3 py-1 rounded-full text-sm font-medium">
              🔄 Dados em Tempo Real
            </div>
          </div>
        </div>
      </div>

      {/* Navegação Rápida */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">🚀 Navegação Rápida</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <button
            onClick={() => document.getElementById('performance-mensal')?.scrollIntoView({ behavior: 'smooth' })}
            className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg hover:border-blue-500 dark:hover:border-blue-400 transition-colors group"
          >
            <div className="text-center">
              <div className="text-2xl mb-2 group-hover:scale-110 transition-transform">📈</div>
              <h4 className="font-semibold text-gray-900 dark:text-white">Performance</h4>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">KPIs mensais</p>
            </div>
          </button>

          <button
            onClick={() => document.getElementById('dre-detalhado')?.scrollIntoView({ behavior: 'smooth' })}
            className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg hover:border-green-500 dark:hover:border-green-400 transition-colors group"
          >
            <div className="text-center">
              <div className="text-2xl mb-2 group-hover:scale-110 transition-transform">💰</div>
              <h4 className="font-semibold text-gray-900 dark:text-white">DRE</h4>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">Financeiro</p>
            </div>
          </button>

          <button
            onClick={() => document.getElementById('analise-clientes')?.scrollIntoView({ behavior: 'smooth' })}
            className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg hover:border-purple-500 dark:hover:border-purple-400 transition-colors group"
          >
            <div className="text-center">
              <div className="text-2xl mb-2 group-hover:scale-110 transition-transform">👥</div>
              <h4 className="font-semibold text-gray-900 dark:text-white">Clientes</h4>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">Segmentação</p>
            </div>
          </button>

          <button
            onClick={() => document.getElementById('eficiencia-frota')?.scrollIntoView({ behavior: 'smooth' })}
            className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg hover:border-orange-500 dark:hover:border-orange-400 transition-colors group"
          >
            <div className="text-center">
              <div className="text-2xl mb-2 group-hover:scale-110 transition-transform">🚛</div>
              <h4 className="font-semibold text-gray-900 dark:text-white">Frota</h4>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">Operacional</p>
            </div>
          </button>
        </div>
      </div>

      {/* Painel de Relatórios */}
      <ReportsPanel />

      {/* Informações Adicionais */}
      <div className="bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/20 dark:to-purple-900/20 rounded-xl border border-blue-200 dark:border-blue-700 p-6">
        <div className="flex items-start space-x-4">
          <div className="text-3xl">💡</div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              Sobre os Relatórios VIPLOC
            </h3>
            <div className="text-gray-700 dark:text-gray-300 space-y-2">
              <p>• <strong>Dados Reais:</strong> Todos os relatórios utilizam dados reais do banco de dados SQLite</p>
              <p>• <strong>Tempo Real:</strong> Informações atualizadas automaticamente do sistema</p>
              <p>• <strong>Exportação:</strong> Relatórios podem ser baixados em Excel (.xlsx)</p>
              <p>• <strong>API Funcional:</strong> Backend rodando em http://localhost:3001</p>
              <p>• <strong>Performance:</strong> Dados de receita atual: R$ 129.800 | Taxa de utilização: 25%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReportsPage